import { render, staticRenderFns } from "./ApplicationPersonInfo1.vue?vue&type=template&id=516aba01&scoped=true&"
import script from "./ApplicationPersonInfo1.vue?vue&type=script&lang=js&"
export * from "./ApplicationPersonInfo1.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPersonInfo1.vue?vue&type=style&index=0&id=516aba01&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516aba01",
  null
  
)

export default component.exports